"use strict";
/**
 * publicOpininonMgrZjNavModule Module
 * Description 显示设置 最新话题规则管理 突发新闻规则管理 历史热点管理 nav切换
 * Author: 于再洋 2017-12-24
 */
angular.module('publicOpininonMgrZjNavModule', [])
    .controller('publicOpininonMgrZjNavctrl', ["$scope", "$location", "trsHttpService", function($scope, $location, trsHttpService) {
        initStatus();
        initData();

        function initStatus() {
            $scope.currRegionalHotspotsModule = $location.path().split("/").pop();
            $scope.publicOpininonMgrZjNavTab = {
                'functionlist': false,
                'displaySetting': false,
                'newTopicRule': false,
                'burstNewsRule': false,
                'historyHotAdmin': false,
            };
            $scope.publicOpininonMgrZjNavTab[$scope.currRegionalHotspotsModule] = true;
        }

        function initData() {            
        }
    }]);
